export default "__VITE_ASSET__BGO43TwC__"